/* eslint-disable no-restricted-globals */
/* eslint-disable import/no-unused-modules */
import React, { ReactElement } from 'react'

import { Link, useNavigate } from 'react-router-dom'
import {
  StyledAdminTemplate,
  StyledImg,
  StyledIcons,
  GoBack,
  StyledA,
  Navigaton,
  NavigationItem,
} from './styled-components'
import logo from '../../assets/images/logo.png'
import Button from '../button'
import Text from '../text'
import Icon from '../icon'

export interface AdminTemplateProps {
  onAddClick?: () => void
  children: ReactElement | ReactElement[]
  childrenBar?: ReactElement | ReactElement[]
  adminTemplate?: boolean
  navigation?: { title: string; link: string }[]
  showAdd?: boolean
}

function AdminTemplate({
  children,
  onAddClick,
  adminTemplate,
  navigation,
  showAdd = false,
  childrenBar,
}: AdminTemplateProps): ReactElement {
  const navigate = useNavigate()
  const logOut = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('redirectUrl')
    navigate(0)
  }
  return (
    <StyledAdminTemplate showAdd={showAdd}>
      <Link to="/">
        <StyledImg src={logo} alt="logo" />
      </Link>
      <Button onClick={logOut} color="white">
        <Text>تسجيل الخروج</Text>
      </Button>
      <Navigaton>
        {navigation?.map((item, index) => (
          <NavigationItem key={index}>
            <Icon
              name="ic:round-navigate-next"
              color="red"
              rotate="180deg"
              width={30}
              height={30}
            />
            <StyledA key={item.title} href={item.link}>
              <Text size="small" weight="bold">
                {item.title}
              </Text>
            </StyledA>
          </NavigationItem>
        ))}
      </Navigaton>

      {adminTemplate ? (
        <>
          <GoBack>
            <StyledIcons onClick={onAddClick}>
              <Icon
                name="fluent:add-square-24-regular"
                color="red"
                width={40}
                height={40}
              />
            </StyledIcons>
            {childrenBar}
            <StyledIcons onClick={() => navigate(-1)}>
              <Icon
                name="ion:arrow-back-circle-outline"
                color="red"
                rotate="180deg"
                width={40}
                height={40}
              />
            </StyledIcons>
          </GoBack>
        </>
      ) : null}

      {children}
    </StyledAdminTemplate>
  )
}

export default AdminTemplate
